export const CSS_WEIGHTS = [
  {
    text: "100 (Thin)",
    shortText: "Thin",
    value: 100
  },
  {
    text: "200 (Extra Light)",
    shortText: "Extra L.",
    value: 200
  },
  {
    text: "300 (Light)",
    shortText: "Light",
    value: 300
  },
  {
    text: "400 (Normal)",
    shortText: "Normal",
    value: 400
  },
  {
    text: "500 (Medium)",
    shortText: "Medium",
    value: 500
  },
  {
    text: "600 (Semi Bold)",
    shortText: "Semi",
    value: 600
  },
  {
    text: "700 (Bold)",
    shortText: "Bold",
    value: 700
  },
  {
    text: "800 (Extra Bold)",
    shortText: "Extra B.",
    value: 800
  },
  {
    text: "900 (Black)",
    shortText: "Black",
    value: 900
  }
];
